export const originatorContextDetail = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  gun: 'com.hp.cdm.domain.telemetry.type.originatorContextDetail.originator.ucdeCloudWebApp.version.1',
  description: 'Schema for CDM originatorContext detail used by Cloud WebApps',
  type: 'object',
  version: '1.1.0',
  definitions: {
    originatorContextDetail: {
      type: 'object',
      required: ['version'],
      properties: {
        version: {
          $ref: 'com.hp.cdm.domain.glossary.version.1.schema.json#/definitions/version',
        },
        associatedDeviceUuid: {
          _producer: 'cloud-webapp',
          description:
            'Device Uuid of the imagingDevice associated with this event if available',
          $ref: 'com.hp.cdm.domain.glossary.version.1.schema.json#/definitions/uuid',
        },
        associatedDeviceProductNumber: {
          _comment:
            '// TODO:  This definition should probably be moved to commonGlossary',
          _producer: 'cloud-webapp',
          description:
            'HP Device Product Number associated with this event if available',
          type: 'string',
          pattern: '[A-Z0-9]+',
          minLength: 6,
          maxLength: 8,
          _examples: ['A7F66A'],
        },
        associatedStratusUserId: {
          _comment:
            '// TODO:  Need to lock down more with regex or enum and examples.  Perhaps make this commonGlossary.',
          _producer: 'cloud-webapp',
          type: 'string',
          maxLength: 256,
          description:
            'Stratus UserID of the user associated with this event if available',
          examples: [''],
        },
        ucdeFqTenantId: {
          _producer: 'cloud-webapp',
          description: 'Fully qualified tenancy path identifier',
          type: 'string',
          pattern:
            '/5c1c2547bf965dee00465a3b(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})+$',
          _examples: [
            '/5c1c2547bf965dee00465a3b/c1a46987-cbd3-45db-b94a-a6544116fc2d/072b5ffd-476b-4290-b66b-828a9029722a/e3e2c6d5-44db-4c9f-95ab-8efe5a8b475e',
          ],
        },
        ucdeTenantId: {
          _producer: 'cloud-webapp',
          description: 'Tenancy ID (leaf-node)',
          $ref: 'com.hp.cdm.domain.glossary.version.1.schema.json#/definitions/uuid',
        },
        ucdeTenantUserResourceId: {
          _comment:
            'This appears to be a 24 character hex encoded string, it is not an MongoDB oid as it doesnt seem to\nfollow the mongo oid decoding pattern. It could me a generically definied oid with the same length.\nIt could also be from crc-96 or crypt16 algorithm.',
          description:
            'UserResourceId for Tenant.   This is distinct from stratusUserId',
          type: 'string',
          minLength: 24,
          maxLength: 24,
          pattern: '^[a-f0-9]+$',
          _examples: [
            '642fc7cdac952d01c92ba233',
            '64394b50ac952d01c92bcd4e',
            '64394bfd1533267b137340b8',
          ],
        },
        ucdeCorrelationId: {
          _producer: 'cloud-webapp',
          description:
            'Cloud service correlation linking key, utilize x-reference-id header unless otherwise specified',
          type: 'string',
          maxLength: 256,
        },
      },
      additionalProperties: false,
    },
  },
  id: 'https://schemaregistry.analysis.ext.hp.com/cdm/gun/com.hp.cdm.domain.telemetry.type.originatorContextDetail.originator.ucdeCloudWebApp.version.1.schema.json',
  jsonSchemaGun:
    'com.hp.cdm.domain.telemetry.type.originatorContextDetail.originator.ucdeCloudWebApp.version.1.schema.json',
  additionalProperties: false,
};
